// eslint-disable-next-line no-restricted-imports -- Use the SDK contract for boundary types.
import { type PostHogConfig } from 'posthog-js';

import { stripUrlQueries } from './stripUrlQueries';

export const staffPostHogOptions: Partial<PostHogConfig> = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24',
  autocapture: false,
  capture_performance: false,
  disable_session_recording: true,
  capture_pageview: false,
  capture_pageleave: false,
  before_send: (event) => stripUrlQueries(event),
};
